// Component: MobileHeader.jsx (ds)
// Purpose: Large-title phone header, generalized from shell/MobileHeader.jsx.
//   A muted status/subtitle line (with an optional connection dot) sits above a
//   big page title; a right cluster holds arbitrary action buttons plus an
//   optional session-ring avatar (brand-gradient fill). Honors --safe-top.
//   Styling in ds-components.css (.ds-mhdr-*).
//
// Usage:
//   <MobileHeader
//     title="Dashboard" subtitle="Markets open · IST" status={{ connected }}
//     actions={[{ key: "search", icon: <SearchIcon/>, onClick, "aria-label": "Search" }]}
//     avatar={{ initial: "D", onClick: openMore }}
//   />

import React from "react";
import { motion } from "framer-motion";
import { cx } from "./cx";
import { TAP } from "./motion";

export function MobileHeader({
  title,
  subtitle,
  status,
  actions = [],
  avatar,
  className,
  ...props
}) {
  const hasLead = status != null || subtitle != null;
  return (
    <header className={cx("ds-mhdr", className)} {...props}>
      <div className="ds-mhdr-top">
        {hasLead ? (
          <span className="ds-mhdr-subtitle">
            {status != null && (
              <span className={cx("ds-mhdr-dot", status.connected && "is-connected")} aria-hidden="true" />
            )}
            {subtitle}
          </span>
        ) : (
          <span />
        )}

        <div className="ds-mhdr-actions">
          {actions.map((a) => (
            <motion.button
              key={a.key}
              type="button"
              aria-label={a["aria-label"]}
              onClick={a.onClick}
              whileTap={TAP}
              className="ds-mhdr-action"
            >
              {a.icon}
            </motion.button>
          ))}

          {avatar && (
            <motion.button
              type="button"
              aria-label={avatar["aria-label"] || "Account and menu"}
              onClick={avatar.onClick}
              whileTap={TAP}
              className="ds-mhdr-avatar"
            >
              <svg width="32" height="32" viewBox="0 0 32 32" className="ds-mhdr-avatar-ring">
                <circle cx="16" cy="16" r="14" fill="none" stroke="var(--bg-3)" strokeWidth="2" />
                <circle
                  cx="16"
                  cy="16"
                  r="14"
                  fill="none"
                  stroke="var(--color-profit)"
                  strokeWidth="2"
                  strokeDasharray="88"
                  strokeDashoffset="22"
                  strokeLinecap="round"
                  transform="rotate(-90 16 16)"
                />
              </svg>
              <span className="ds-mhdr-avatar-fill">{avatar.initial}</span>
            </motion.button>
          )}
        </div>
      </div>

      <h1 className="ds-mhdr-title">{title}</h1>
    </header>
  );
}

export default MobileHeader;
